import { useWizard } from "react-use-wizard";
import {
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import tradeInSteps from "./tradeInSteps";
import FacilityTypeStep_2 from "../../../../../shared/wizard/steps/facilityTypeStep_2";

interface ITradeInStep_2 {
  isNextStepDisabled: boolean;
  onChange: (data: number, key: TNumberKeysOfIFillDataWizardTradeIn) => void;
  data: number | null;
  onReset: (key: TKeyOfDataWizardTradeIn[]) => void;
}

const TradeInStep_2 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ITradeInStep_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_1.step);
    onReset(["selectedFacilityTypeOwnFacility"]);
  };

  const handleNextStep = () => {
    goToStep(tradeInSteps.step_3.step);
  };

  const handleChange = (selectedId: number) => {
    onChange(selectedId, "selectedFacilityTypeOwnFacility");
  };

  return (
    <div>
      <FacilityTypeStep_2
        counterPage={{
          current: tradeInSteps.step_2.page,
          max: tradeInSteps.step_2.maxPage,
        }}
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data ? [data] : []}
        mode="default"
        text={"Количество комнат в вашей старой квартире:"}
      />
    </div>
  );
};

export default TradeInStep_2;
